import { useFeatureFlagEnabled, usePostHog } from 'hooks/usePostHogSafe';
import usePermission from 'hooks/usePermission';

const SURVEYS_FEATURE_FLAG = 'surveys';

/**
 * 'pending' | 'allowed' | 'denied'. Shared by the side-nav tab and the page, so
 * the link never shows where the page would 404.
 */
const useSurveysAccess = () => {
  const posthog = usePostHog();
  const flag = useFeatureFlagEnabled(SURVEYS_FEATURE_FLAG);
  const access = usePermission('read:surveys');

  // No PostHog on the server, so the flag reads false there: wait, don't 404.
  if (!posthog) return 'pending';
  if (!flag) return 'denied';
  return access;
};

export default useSurveysAccess;
